"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusedOnConversationMessageInput = void 0;

var _Schema = require("../../Schema");

/**
 * A user focuses the message input on web collector inbox
 *
 * @example
 * ```
 * focusedOnConversationMessageInput({
 *   impulseConversationId: "12345"
 * })
 * ```
 */
var focusedOnConversationMessageInput = function focusedOnConversationMessageInput(_ref) {
  var impulseConversationId = _ref.impulseConversationId;
  return {
    action: _Schema.ActionType.focusedOnConversationMessageInput,
    impulse_conversation_id: impulseConversationId
  };
};

exports.focusedOnConversationMessageInput = focusedOnConversationMessageInput;